import axios from "axios";

/**
 * 이메일 문의 API
 * @param {string} obj.name - 이름
 * @param {string} obj.email - 이메일
 * @param {string} obj.phone - 연락처
 * @param {string} obj.content - 내용
 * @returns {Promise}
 */
function sendFAQ({ name, email, phone, content}) {
  return axios({
    url: `/boards/faq`,
    method: 'POST',
    data: {
      name,
      email,
      phone,
      content
    }
  });
}

export default sendFAQ;
